import _toConsumableArray from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.string.split.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue";
import _imports_0 from '@/assets/images/icons/total_cashfloat_icon.png';
import _imports_1 from '@/assets/images/icons/detailed_cashfloat_icon.png';
var _hoisted_1 = {
  class: "new-cash-float-open",
  "data-cy": "cash-float-open-modal"
};
var _hoisted_2 = {
  key: 0,
  style: {
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "flex-start",
    "flex-wrap": "wrap",
    "padding-left": "15%",
    "padding-right": "15%",
    "height": "85%"
  }
};
var _hoisted_3 = {
  style: {
    "width": "100%",
    "text-align": "center",
    "height": "fit-content"
  }
};

var _hoisted_4 = /*#__PURE__*/_createElementVNode("p", {
  style: {
    "font-size": "35px",
    "margin-bottom": "1%"
  }
}, [/*#__PURE__*/_createElementVNode("strong", null, "Opening Sales")], -1);

var _hoisted_5 = {
  style: {
    "font-size": "30px"
  }
};
var _hoisted_6 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "center",
    "flex-wrap": "wrap",
    "height": "70%",
    "margin-top": "2%"
  }
};
var _hoisted_7 = {
  style: {
    "margin-bottom": "7%"
  }
};

var _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "180px",
    "width": "180px",
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "center",
    "align-items": "center"
  }
}, [/*#__PURE__*/_createElementVNode("img", {
  style: {
    "max-width": "80%",
    "height": "auto"
  },
  src: _imports_0,
  alt: "total cashfloat"
})], -1);

var _hoisted_9 = {
  style: {
    "margin-bottom": "7%"
  }
};

var _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "180px",
    "width": "180px",
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "center",
    "align-items": "center"
  }
}, [/*#__PURE__*/_createElementVNode("img", {
  style: {
    "max-width": "100%",
    "height": "auto"
  },
  src: _imports_1,
  alt: "detailed cashfloat"
})], -1);

var _hoisted_11 = {
  key: 0,
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "flex-start",
    "padding-top": "5px",
    "width": "60%"
  }
};
var _hoisted_12 = {
  key: 1,
  class: "general-cashfloat",
  style: {
    "padding-left": "15%",
    "padding-right": "15%",
    "height": "80%",
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "flex-start",
    "align-self": "center",
    "margin-top": "10%"
  }
};
var _hoisted_13 = {
  style: {
    "text-align": "center",
    "margin-bottom": "10%"
  }
};
var _hoisted_14 = {
  style: {
    "font-size": "30px"
  }
};
var _hoisted_15 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "center"
  }
};
var _hoisted_16 = {
  style: {
    "margin-bottom": "10px"
  }
};
var _hoisted_17 = {
  style: {
    "width": "75px"
  }
};
var _hoisted_18 = ["onClick"];
var _hoisted_19 = {
  key: 0,
  style: {
    "text-align": "center",
    "margin-bottom": "5px",
    "margin-top": "5%"
  }
};

var _hoisted_20 = /*#__PURE__*/_createElementVNode("p", {
  style: {
    "font-size": "20px"
  }
}, "Cash taken from:", -1);

var _hoisted_21 = [_hoisted_20];
var _hoisted_22 = {
  key: 1,
  style: {
    "margin-bottom": "10px",
    "width": "100%"
  }
};
var _hoisted_23 = {
  key: 2,
  style: {
    "margin-bottom": "10px"
  }
};
var _hoisted_24 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-between"
  }
};
var _hoisted_25 = {
  class: "cashfloat-actions"
};
var _hoisted_26 = {
  key: 2,
  class: "general-cashfloat",
  style: {
    "padding-left": "15%",
    "padding-right": "15%",
    "height": "80%",
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "flex-start",
    "align-self": "center",
    "margin-top": "10%"
  }
};
var _hoisted_27 = {
  style: {
    "text-align": "center",
    "margin-bottom": "10%"
  }
};
var _hoisted_28 = {
  style: {
    "font-size": "30px"
  }
};
var _hoisted_29 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "center"
  }
};
var _hoisted_30 = {
  style: {
    "color": "gray"
  }
};
var _hoisted_31 = {
  key: 0,
  style: {
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "center"
  }
};
var _hoisted_32 = {
  style: {
    "color": "gray"
  }
};
var _hoisted_33 = {
  style: {
    "margin-bottom": "10px"
  }
};
var _hoisted_34 = {
  style: {
    "width": "75px"
  }
};
var _hoisted_35 = ["onClick"];
var _hoisted_36 = {
  style: {
    "margin-top": "5px"
  }
};
var _hoisted_37 = {
  style: {
    "color": "gray"
  }
};
var _hoisted_38 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-between",
    "margin-top": "15px"
  }
};
var _hoisted_39 = {
  key: 3,
  style: {
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "center",
    "align-self": "center",
    "width": "50%",
    "margin-top": "2%"
  }
};
var _hoisted_40 = {
  style: {
    "text-align": "center",
    "margin-bottom": "3%",
    "font-size": "30px"
  }
};
var _hoisted_41 = {
  key: 0,
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "flex-end",
    "align-items": "center",
    "margin-bottom": "1%"
  }
};

var _hoisted_42 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "text-align": "center",
    "margin-right": "10px"
  }
}, [/*#__PURE__*/_createElementVNode("p", null, "Cash taken from:")], -1);

var _hoisted_43 = {
  key: 1,
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "flex-end"
  }
};
var _hoisted_44 = {
  style: {
    "height": "54vh",
    "border-radius": "6px",
    "border": "1px solid #a6a6a6",
    "padding": "4%"
  },
  ref: "cashDetailsArea"
};
var _hoisted_45 = {
  key: 0,
  style: {
    "overflow-y": "scroll",
    "height": "45vh"
  }
};
var _hoisted_46 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-between",
    "align-items": "center"
  }
};
var _hoisted_47 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "align-items": "center",
    "gap": "1rem"
  }
};
var _hoisted_48 = {
  key: 1,
  style: {
    "font-size": "35px"
  }
};
var _hoisted_49 = {
  style: {
    "margin-top": "2%",
    "margin-bottom": "2%",
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "center"
  }
};
var _hoisted_50 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "center",
    "border-bottom": "2px solid #ededed",
    "color": "#a6a6a6"
  }
};
var _hoisted_51 = {
  style: {
    "width": "20%",
    "text-align": "left"
  }
};
var _hoisted_52 = {
  style: {
    "width": "20%",
    "text-align": "left"
  }
};
var _hoisted_53 = {
  style: {
    "width": "58%",
    "text-align": "right"
  }
};
var _hoisted_54 = {
  style: {
    "width": "20%",
    "text-align": "left"
  }
};
var _hoisted_55 = {
  style: {
    "width": "20%",
    "text-align": "left"
  }
};
var _hoisted_56 = {
  style: {
    "width": "58%",
    "text-align": "right"
  }
};

var _hoisted_57 = /*#__PURE__*/_createElementVNode("hr", null, null, -1);

var _hoisted_58 = {
  style: {
    "margin-top": "3%",
    "margin-bottom": "2%",
    "display": "flex",
    "flex-direction": "column",
    "justify-content": "center"
  }
};
var _hoisted_59 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "center",
    "border-bottom": "2px solid #ededed",
    "color": "#a6a6a6"
  }
};
var _hoisted_60 = {
  style: {
    "width": "20%",
    "text-align": "left"
  }
};
var _hoisted_61 = {
  style: {
    "width": "20%",
    "text-align": "left"
  }
};
var _hoisted_62 = {
  style: {
    "width": "58%",
    "text-align": "right"
  }
};
var _hoisted_63 = {
  style: {
    "width": "20%",
    "text-align": "left"
  }
};
var _hoisted_64 = {
  style: {
    "width": "20%",
    "text-align": "left"
  }
};
var _hoisted_65 = {
  style: {
    "width": "58%",
    "text-align": "right"
  }
};
var _hoisted_66 = {
  style: {
    "width": "20%",
    "text-align": "left"
  }
};
var _hoisted_67 = {
  style: {
    "color": "#ededed",
    "margin-left": "5px"
  }
};
var _hoisted_68 = {
  style: {
    "width": "20%",
    "text-align": "left"
  }
};
var _hoisted_69 = {
  style: {
    "width": "58%",
    "text-align": "right"
  }
};
var _hoisted_70 = {
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "margin-top": "0.5rem",
    "padding-right": "0.5rem"
  }
};
var _hoisted_71 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "justify-content": "space-between",
    "border-top": "1px solid gray",
    "margin-top": "3%",
    "padding-top": "1.5%"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_button = _resolveComponent("el-button");

  var _component_el_input = _resolveComponent("el-input");

  var _component_el_option = _resolveComponent("el-option");

  var _component_el_select = _resolveComponent("el-select");

  var _component_el_checkbox = _resolveComponent("el-checkbox");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [!_ctx.isGeneralCashfloat && !_ctx.isDetailedCashfloat ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("p", _hoisted_5, _toDisplayString(String(_ctx.t("cashfloat.please-process")).replace("xxx", _ctx.userFirstName)), 1)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.toggleCashfloatType(_ctx.CashfloatType.General);
    }),
    style: {
      "width": "25%",
      "height": "80%",
      "text-align": "center",
      "display": "flex",
      "flex-direction": "column",
      "justify-content": "center",
      "align-items": "center",
      "border": "1px solid gray",
      "border-radius": "5px",
      "padding": "5%",
      "padding-top": "0%",
      "margin": "5%",
      "margin-top": "2%"
    },
    "data-cy": "general-cashfloat-button"
  }, [_createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.t("cashfloat.total-cashfloat")), 1), _hoisted_8]), _createElementVNode("div", {
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.toggleCashfloatType(_ctx.CashfloatType.Detailed);
    }),
    style: {
      "width": "25%",
      "height": "80%",
      "text-align": "center",
      "display": "flex",
      "flex-direction": "column",
      "justify-content": "center",
      "align-items": "center",
      "border": "1px solid gray",
      "border-radius": "5px",
      "padding": "5%",
      "padding-top": "0%",
      "margin": "5%",
      "margin-top": "2%"
    },
    "data-cy": "detailed-cashfloat-button"
  }, [_createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.t("cashfloat.individual-cash")), 1), _hoisted_10]), !_ctx.isGeneralCashfloat && !_ctx.isDetailedCashfloat ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_el_button, {
    onClick: _ctx.cancel,
    style: {
      "height": "35px"
    },
    class: "green-plain"
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t("button.cancel")), 1)];
    }),
    _: 1
  }, 8, ["onClick"])])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), _ctx.isGeneralCashfloat && !_ctx.hasPreviousCashfloatMoney ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("p", _hoisted_14, [_createElementVNode("strong", null, _toDisplayString(_ctx.t("cashfloat.summarized-cash")), 1)])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createVNode(_component_el_input, {
    "data-cy": "cashfloat-amount-input",
    modelValue: _ctx.totalByCurrency[_ctx.groupCurrency],
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return _ctx.totalByCurrency[_ctx.groupCurrency] = $event;
    }),
    onChange: _cache[3] || (_cache[3] = function (val) {
      return _ctx.adjustAmount(val, _ctx.groupCurrency);
    }),
    placeholder: "Add total",
    size: "large",
    type: "number",
    min: 0,
    onFocus: _ctx.handleInputFocus,
    onBlur: _ctx.handleInputBlur
  }, {
    prepend: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.groupCurrency), 1)];
    }),
    _: 1
  }, 8, ["modelValue", "onFocus", "onBlur"])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addedCurrencies, function (currencyLabel, index) {
    return _openBlock(), _createElementBlock("div", {
      key: currencyLabel,
      style: {
        "margin-bottom": "10px"
      }
    }, [_createVNode(_component_el_input, {
      "data-cy": "cashfloat-amount-input",
      modelValue: _ctx.totalByCurrency[currencyLabel],
      "onUpdate:modelValue": function onUpdateModelValue($event) {
        return _ctx.totalByCurrency[currencyLabel] = $event;
      },
      onChange: function onChange(val) {
        return _ctx.adjustAmount(val, currencyLabel);
      },
      placeholder: "Add total",
      size: "large",
      type: "number",
      min: 0,
      onFocus: _ctx.handleInputFocus,
      onBlur: _ctx.handleInputBlur
    }, {
      prepend: _withCtx(function () {
        return [_createVNode(_component_el_select, {
          style: {
            "width": "115px"
          },
          onChange: function onChange(newCurrencyLabel) {
            return _ctx.currencySelectChanged(newCurrencyLabel, currencyLabel);
          },
          modelValue: _ctx.addedCurrencies[index],
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return _ctx.addedCurrencies[index] = $event;
          }
        }, {
          default: _withCtx(function () {
            return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notAddedCurrencies, function (item) {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.label,
                value: item.label
              }, null, 8, ["label", "value"]);
            }), 128))];
          }),
          _: 2
        }, 1032, ["onChange", "modelValue", "onUpdate:modelValue"])];
      }),
      suffix: _withCtx(function () {
        return [_createElementVNode("button", {
          onClick: function onClick($event) {
            return _ctx.removeAddedCurrency(currencyLabel);
          },
          class: "remove-currency-btn"
        }, " X ", 8, _hoisted_18)];
      }),
      _: 2
    }, 1032, ["modelValue", "onUpdate:modelValue", "onChange", "onFocus", "onBlur"])]);
  }), 128)), _ctx.hasLocation ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21)) : _createCommentVNode("", true), _ctx.hasLocation ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createVNode(_component_el_select, {
    modelValue: _ctx.locationId,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
      return _ctx.locationId = $event;
    }),
    placeholder: _ctx.$t('location'),
    size: "large",
    class: "w-100",
    disabled: _ctx.isMoneyAlreadyInDrawer,
    "data-cy": "location-select"
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locationsList, function (item) {
        return _openBlock(), _createBlock(_component_el_option, {
          key: Number(item.id),
          label: String(item.name),
          value: Number(item.id),
          "data-cy": "location-option"
        }, null, 8, ["label", "value"]);
      }), 128))];
    }),
    _: 1
  }, 8, ["modelValue", "placeholder", "disabled"])])) : _createCommentVNode("", true), _ctx.hasLocation ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createVNode(_component_el_checkbox, {
    disabled: !_ctx.hasPreviousCashfloatMoney,
    modelValue: _ctx.isMoneyAlreadyInDrawer,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
      return _ctx.isMoneyAlreadyInDrawer = $event;
    }),
    label: _ctx.$t('cashfloat.money-already-in-the-drawer'),
    size: "large",
    onChange: _ctx.resetLocationId
  }, null, 8, ["disabled", "modelValue", "label", "onChange"])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_24, [_ctx.notAddedCurrencies.length && _ctx.hasMultiCurrenciesEnabled ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    onClick: _ctx.addCurrency,
    style: {
      "height": "35px"
    },
    class: "green-plain"
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t("multicurrencies.add-currency")), 1)];
    }),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_25, [_createVNode(_component_el_button, {
    onClick: _ctx.cancel,
    class: "cancel-button",
    disabled: _ctx.submitingCashFloat,
    "data-cy": "cancel-button"
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t("button.cancel")), 1)];
    }),
    _: 1
  }, 8, ["onClick", "disabled"]), _createVNode(_component_el_button, {
    style: _normalizeStyle({
      visibility: _ctx.canConfirmGeneralCashfloat ? 'visible' : 'hidden'
    }),
    onClick: _ctx.submitGeneralCashfloat,
    loading: _ctx.submitingCashFloat,
    class: "confirm-button",
    "data-cy": "confirm-button"
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t("button.confirm")), 1)];
    }),
    _: 1
  }, 8, ["style", "onClick", "loading"])])])) : _createCommentVNode("", true), _ctx.isGeneralCashfloat && _ctx.hasPreviousCashfloatMoney ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("p", _hoisted_28, [_createElementVNode("strong", null, _toDisplayString(_ctx.t("cashfloat.summarized-cash")), 1)])]), _createElementVNode("div", _hoisted_29, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currencies, function (currency) {
    return _openBlock(), _createElementBlock("div", {
      key: currency.id,
      style: {
        "margin-bottom": "10px"
      }
    }, [_createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.t("cashfloat.initial-cashfloat")), 1), _createVNode(_component_el_input, {
      disabled: "",
      modelValue: _ctx.previousCashfloatAmounts[currency.label],
      "onUpdate:modelValue": function onUpdateModelValue($event) {
        return _ctx.previousCashfloatAmounts[currency.label] = $event;
      },
      placeholder: "Add total",
      size: "large",
      type: "number",
      min: 0,
      onFocus: _ctx.handleInputFocus,
      onBlur: _ctx.handleInputBlur,
      "data-cy": "existing-cashfloat-amount-input"
    }, {
      append: _withCtx(function () {
        return [_createTextVNode(_toDisplayString(currency.label), 1)];
      }),
      _: 2
    }, 1032, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"])]);
  }), 128)), _createVNode(_component_el_checkbox, {
    checked: "",
    disabled: "",
    label: "Money already in the drawer",
    size: "large"
  }), _createElementVNode("div", null, [!_ctx.showEditExistingAmountArea ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    onClick: _ctx.toggleShowEditExistingAmount,
    size: "large w-100",
    type: "primary",
    "data-cy": "edit-existing-amount-button"
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t("cashfloat.add-different-amount")), 1)];
    }),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true)]), _ctx.showEditExistingAmountArea ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.t("cashfloat.manual-cashfloat")), 1), _createElementVNode("div", _hoisted_33, [_createVNode(_component_el_input, {
    modelValue: _ctx.totalByCurrency[_ctx.groupCurrency],
    "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
      return _ctx.totalByCurrency[_ctx.groupCurrency] = $event;
    }),
    onChange: _cache[7] || (_cache[7] = function (val) {
      return _ctx.adjustAmount(val, _ctx.groupCurrency);
    }),
    placeholder: "Add total",
    size: "large",
    type: "number",
    min: 0,
    onFocus: _ctx.handleInputFocus,
    onBlur: _ctx.handleInputBlur,
    "data-cy": "cashfloat-amount-input"
  }, {
    prepend: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.groupCurrency), 1)];
    }),
    _: 1
  }, 8, ["modelValue", "onFocus", "onBlur"])]), _createElementVNode("div", null, [_createElementVNode("strong", null, _toDisplayString(_ctx.t("cashfloat.difference")) + " : " + _toDisplayString(_ctx.cashfloatOpeningAmounts[_ctx.groupCurrency] - (_ctx.previousCashfloatAmounts[_ctx.groupCurrency] || 0)) + " " + _toDisplayString(_ctx.groupCurrency), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addedCurrencies, function (currencyLabel, index) {
    return _openBlock(), _createElementBlock("div", {
      key: currencyLabel,
      style: {
        "margin-bottom": "10px"
      }
    }, [_createVNode(_component_el_input, {
      modelValue: _ctx.totalByCurrency[currencyLabel],
      "onUpdate:modelValue": function onUpdateModelValue($event) {
        return _ctx.totalByCurrency[currencyLabel] = $event;
      },
      onChange: function onChange(val) {
        return _ctx.adjustAmount(val, currencyLabel);
      },
      placeholder: "Add total",
      size: "large",
      type: "number",
      min: 0,
      onFocus: _ctx.handleInputFocus,
      onBlur: _ctx.handleInputBlur,
      "data-cy": "cashfloat-amount-input"
    }, {
      prepend: _withCtx(function () {
        return [_createVNode(_component_el_select, {
          style: {
            "width": "115px"
          },
          onChange: function onChange(newCurrencyLabel) {
            return _ctx.currencySelectChanged(newCurrencyLabel, currencyLabel);
          },
          modelValue: _ctx.addedCurrencies[index],
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return _ctx.addedCurrencies[index] = $event;
          }
        }, {
          default: _withCtx(function () {
            return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notAddedCurrencies, function (item) {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.label,
                value: item.label
              }, null, 8, ["label", "value"]);
            }), 128))];
          }),
          _: 2
        }, 1032, ["onChange", "modelValue", "onUpdate:modelValue"])];
      }),
      suffix: _withCtx(function () {
        return [_createElementVNode("button", {
          onClick: function onClick($event) {
            return _ctx.removeAddedCurrency(currencyLabel);
          },
          class: "remove-currency-btn"
        }, " X ", 8, _hoisted_35)];
      }),
      _: 2
    }, 1032, ["modelValue", "onUpdate:modelValue", "onChange", "onFocus", "onBlur"]), _createElementVNode("div", null, [_createElementVNode("strong", null, _toDisplayString(_ctx.t("cashfloat.difference")) + " : " + _toDisplayString(_ctx.cashfloatOpeningAmounts[currencyLabel] - (_ctx.previousCashfloatAmounts[currencyLabel] || 0)) + " " + _toDisplayString(currencyLabel), 1)])]);
  }), 128)), _createElementVNode("div", _hoisted_36, [_createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.t("cashfloat.manual-amount-differes-from-initial-amount-please-enter-note")), 1), _createVNode(_component_el_input, {
    "data-cy": "cash-difference-note-input",
    modelValue: _ctx.cashDifferenceNote,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) {
      return _ctx.cashDifferenceNote = $event;
    }),
    rows: 3,
    type: "textarea",
    placeholder: _ctx.t('cashfloat.write-your-note-here')
  }, null, 8, ["modelValue", "placeholder"])])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_38, [_createVNode(_component_el_button, {
    onClick: _ctx.cancel,
    style: {
      "height": "35px"
    },
    class: "green-plain w-50",
    disabled: _ctx.submitingCashFloat,
    "data-cy": "cancel-button"
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t("button.cancel")), 1)];
    }),
    _: 1
  }, 8, ["onClick", "disabled"]), _createVNode(_component_el_button, {
    onClick: _ctx.submitGeneralCashfloatWhenMoneyAlreadyExistingInDrawer,
    loading: _ctx.submitingCashFloat,
    style: {
      "height": "35px"
    },
    class: "green-plain w-50",
    type: "primary",
    "data-cy": "confirm-button"
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t("button.confirm")), 1)];
    }),
    _: 1
  }, 8, ["onClick", "loading"])])])) : _createCommentVNode("", true), _ctx.isDetailedCashfloat ? (_openBlock(), _createElementBlock("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_createElementVNode("p", null, [_createElementVNode("strong", null, _toDisplayString(_ctx.t("cashfloat.detailed")), 1)])]), _ctx.hasLocation ? (_openBlock(), _createElementBlock("div", _hoisted_41, [_hoisted_42, _createElementVNode("div", null, [_createVNode(_component_el_select, {
    modelValue: _ctx.locationId,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) {
      return _ctx.locationId = $event;
    }),
    placeholder: _ctx.$t('location'),
    disabled: _ctx.isMoneyAlreadyInDrawer,
    "data-cy": "location-select"
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locationsList, function (item) {
        return _openBlock(), _createBlock(_component_el_option, {
          key: Number(item.id),
          label: String(item.name),
          value: Number(item.id)
        }, null, 8, ["label", "value"]);
      }), 128))];
    }),
    _: 1
  }, 8, ["modelValue", "placeholder", "disabled"])])])) : _createCommentVNode("", true), _ctx.hasLocation ? (_openBlock(), _createElementBlock("div", _hoisted_43, [_createVNode(_component_el_checkbox, {
    disabled: !_ctx.hasPreviousCashfloatMoney,
    modelValue: _ctx.isMoneyAlreadyInDrawer,
    "onUpdate:modelValue": _cache[10] || (_cache[10] = function ($event) {
      return _ctx.isMoneyAlreadyInDrawer = $event;
    }),
    label: "Money already in the drawer",
    onChange: _ctx.resetLocationId
  }, null, 8, ["disabled", "modelValue", "onChange"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_44, [_ctx.detailedGroupCurrency ? (_openBlock(), _createElementBlock("div", _hoisted_45, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList([_ctx.detailedGroupCurrency].concat(_toConsumableArray(_ctx.addedDetailedCurrencies)), function (curr, index) {
    return _openBlock(), _createElementBlock("div", {
      key: curr.id
    }, [_createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [curr.label !== _ctx.groupCurrency ? (_openBlock(), _createBlock(_component_el_select, {
      key: 0,
      onChange: function onChange(newCurrencyLabel) {
        return _ctx.currencySelectChangedCoinsAndBills(newCurrencyLabel, curr.label, index - 1);
      },
      placeholder: _ctx.addedDetailedCurrencies[index - 1].detailedName,
      class: "detailed-currencies-select",
      style: {
        "margin-top": "1.5rem"
      }
    }, {
      default: _withCtx(function () {
        return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notAddedCurrenciesCoinsAndBills, function (item) {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.id,
            label: item.detailedName,
            value: item.id
          }, null, 8, ["label", "value"]);
        }), 128))];
      }),
      _: 2
    }, 1032, ["onChange", "placeholder"])) : (_openBlock(), _createElementBlock("p", _hoisted_48, _toDisplayString(curr.detailedName), 1))]), curr.label !== _ctx.groupCurrency ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      onClick: function onClick($event) {
        return _ctx.removeAddedCurrencyCoinsAndBills(curr.label);
      },
      type: "danger"
    }, {
      default: _withCtx(function () {
        return [_createTextVNode("Remove")];
      }),
      _: 2
    }, 1032, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, [_createElementVNode("p", null, _toDisplayString(_ctx.t("cashfloat.bills")), 1)]), _createElementVNode("div", _hoisted_52, [_createElementVNode("p", null, _toDisplayString(_ctx.t("cashfloat.amount")), 1)]), _createElementVNode("div", _hoisted_53, [_createElementVNode("p", null, _toDisplayString(_ctx.t("cashfloat.value")), 1)])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(curr.bills, function (bill) {
      return _openBlock(), _createElementBlock("div", {
        key: bill,
        style: {
          "display": "flex",
          "flex-direction": "row",
          "justify-content": "center",
          "align-items": "center",
          "border-bottom": "1px solid #ededed",
          "padding-bottom": "1%",
          "padding-top": "1%"
        }
      }, [_createElementVNode("div", _hoisted_54, [_createElementVNode("p", null, [_createElementVNode("strong", null, _toDisplayString(bill.name), 1)])]), _createElementVNode("div", _hoisted_55, [_createVNode(_component_el_input, {
        modelValue: bill.userInput,
        "onUpdate:modelValue": function onUpdateModelValue($event) {
          return bill.userInput = $event;
        },
        type: "number",
        min: 0,
        onFocus: _ctx.handleInputFocus,
        onBlur: _ctx.handleInputBlur
      }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"])]), _createElementVNode("div", _hoisted_56, [_createElementVNode("p", null, [_createElementVNode("strong", null, _toDisplayString(curr.symbol + " " + (Number(bill.name) * (bill.userInput ? bill.userInput : 0)).toLocaleString("en-EN", {
        /*style: "currency",
        currency: "en-EN",*/
        minimumFractionDigits: 2,

        /*minimumIntegerDigits: 3,*/
        maximumFractionDigits: 2
      }).split(",").join("'")), 1)])])]);
    }), 128))]), _hoisted_57, _createElementVNode("div", _hoisted_58, [_createElementVNode("div", _hoisted_59, [_createElementVNode("div", _hoisted_60, [_createElementVNode("p", null, _toDisplayString(_ctx.t("cashfloat.coins")), 1)]), _createElementVNode("div", _hoisted_61, [_createElementVNode("p", null, _toDisplayString(_ctx.t("cashfloat.amount")), 1)]), _createElementVNode("div", _hoisted_62, [_createElementVNode("p", null, _toDisplayString(_ctx.t("cashfloat.value")), 1)])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(curr.coins, function (coin) {
      return _openBlock(), _createElementBlock("div", {
        key: coin,
        style: {
          "display": "flex",
          "flex-direction": "row",
          "justify-content": "center",
          "align-items": "center",
          "border-bottom": "1px solid #ededed",
          "padding-bottom": "1%",
          "padding-top": "1%"
        }
      }, [_createElementVNode("div", _hoisted_63, [_createElementVNode("p", null, [_createElementVNode("strong", null, _toDisplayString(coin.name), 1)])]), _createElementVNode("div", _hoisted_64, [_createVNode(_component_el_input, {
        modelValue: coin.userInput,
        "onUpdate:modelValue": function onUpdateModelValue($event) {
          return coin.userInput = $event;
        },
        type: "number",
        min: 0,
        onFocus: _ctx.handleInputFocus,
        onBlur: _ctx.handleInputBlur
      }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"])]), _createElementVNode("div", _hoisted_65, [_createElementVNode("p", null, [_createElementVNode("strong", null, _toDisplayString(curr.symbol + " " + (Number(coin.name) * (coin.userInput ? coin.userInput : 0)
      /*.toFixed(2)*/
      ).toLocaleString("en-EN", {
        /*style: "currency",
        currency: "en-EN",*/
        minimumFractionDigits: 2,

        /*minimumIntegerDigits: 3,*/
        maximumFractionDigits: 2
      }).split(",").join("'")), 1)])])]);
    }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(curr.cents, function (cent) {
      return _openBlock(), _createElementBlock("div", {
        key: cent,
        style: {
          "display": "flex",
          "flex-direction": "row",
          "justify-content": "center",
          "align-items": "center",
          "border-bottom": "1px solid #ededed",
          "padding-bottom": "1%",
          "padding-top": "1%"
        }
      }, [_createElementVNode("div", _hoisted_66, [_createElementVNode("p", null, [_createElementVNode("strong", null, [_createTextVNode(_toDisplayString(cent.name), 1), _createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.t("cashfloat.cents")), 1)])])]), _createElementVNode("div", _hoisted_68, [_createVNode(_component_el_input, {
        modelValue: cent.userInput,
        "onUpdate:modelValue": function onUpdateModelValue($event) {
          return cent.userInput = $event;
        },
        type: "number",
        min: 0,
        onFocus: _ctx.handleInputFocus,
        onBlur: _ctx.handleInputBlur
      }, null, 8, ["modelValue", "onUpdate:modelValue", "onFocus", "onBlur"])]), _createElementVNode("div", _hoisted_69, [_createElementVNode("p", null, [_createElementVNode("strong", null, _toDisplayString(curr.symbol + " " + (Number(cent.name) * (cent.userInput ? cent.userInput : 0) / 100
      /*.toFixed(2)*/
      ).toLocaleString("en-EN", {
        /*style: "currency",
        currency: "en-EN",*/
        minimumFractionDigits: 2,

        /*minimumIntegerDigits: 3,*/
        maximumFractionDigits: 2
      }).split(",").join("'")), 1)])])]);
    }), 128)), _createElementVNode("div", _hoisted_70, [_createElementVNode("div", null, [_createElementVNode("p", null, [_createElementVNode("strong", null, _toDisplayString(_ctx.t("cashfloat.total-cashfloat-in")) + " " + _toDisplayString(curr.label), 1)])]), _createElementVNode("div", null, [_createElementVNode("p", null, [_createElementVNode("strong", null, _toDisplayString(curr.symbol) + " " + _toDisplayString(_ctx.sumCashByCurrency(curr.id)
    /*.toFixed(2)*/
    .toLocaleString("en-EN", {
      /*style: "currency",
      currency: "en-EN",*/
      minimumFractionDigits: 2,

      /*minimumIntegerDigits: 3,*/
      maximumFractionDigits: 2
    }).split(",").join("'")), 1)])])])])]);
  }), 128)), _ctx.notAddedCurrenciesCoinsAndBills.length && _ctx.hasMultiCurrenciesEnabled ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    onClick: _ctx.addCurrencyCoinsAndBills,
    style: {
      "height": "35px",
      "margin-top": "1rem",
      "margin-bottom": "1rem",
      "width": "30%",
      "margin-left": "70%"
    },
    class: "green-plain"
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t("multicurrencies.add-currency")), 1)];
    }),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 512), _createElementVNode("div", _hoisted_71, [false ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    onClick: _ctx.scrollToTop,
    style: {
      "height": "35px"
    },
    class: "green-plain",
    type: "primary",
    "data-cy": "scroll-top-button"
  }, {
    default: _withCtx(function () {
      return [_createTextVNode("Scroll Top")];
    }),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
    onClick: _ctx.cancel,
    style: {
      "height": "35px"
    },
    class: "green-plain",
    disabled: _ctx.submitingCashFloat,
    "data-cy": "cancel-button"
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t("button.cancel")), 1)];
    }),
    _: 1
  }, 8, ["onClick", "disabled"]), _ctx.canConfirmDetailedCashfloat ? (_openBlock(), _createBlock(_component_el_button, {
    key: 1,
    onClick: _ctx.submitDetailedCashfloat,
    loading: _ctx.submitingCashFloat,
    style: {
      "height": "35px"
    },
    class: "green-plain",
    type: "primary",
    "data-cy": "confirm-button"
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t("button.confirm")), 1)];
    }),
    _: 1
  }, 8, ["onClick", "loading"])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)]);
}